import isString from 'lodash/isString';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';
import {ANY_CHILD} from 'prop-utils';

class DialogContent extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        let {
            maxHeight,
            isMobile,
            mobileHeightOffset
        } = this.props;

        if (maxHeight) {
            if (isString(maxHeight) && maxHeight === 'auto') {
                const availableHeight = window.innerHeight || document.body.clientHeight;
                maxHeight = (isMobile) ? availableHeight - mobileHeightOffset : availableHeight * 0.8;
            }

            this._container.style.maxHeight = `${maxHeight}px`;
            this._container.style.overflow = 'auto';
        }
    }

    _createMarkup() {
        return {__html: this.props.html};
    }

    render() {
        const {
            className,
            noPadding,
            children,
            html
        } = this.props;
        const content = (html)
            ? <div dangerouslySetInnerHTML={this._createMarkup()} />
            : children;
        const classes = classNames(
            'Dialog-content',
            {'Dialog-content-flush': noPadding},
            className
        );

        return (
            <div className={classes} ref={node => { this._container = node; }}>
                {content}
            </div>
        );
    }
}

DialogContent.propTypes = {
    className: PropTypes.string,
    children: ANY_CHILD,
    noPadding: PropTypes.bool,
    maxHeight: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf(['auto'])
    ]),
    html: PropTypes.string,
    isMobile: PropTypes.bool,
    mobileHeightOffset: PropTypes.number
};

DialogContent.defaultProps = {
    maxHeight: 'auto',
    isMobile: false,
    mobileHeightOffset: 60
};

export default DialogContent;



// WEBPACK FOOTER //
// ./frontend/src/js/components/dialog/DialogContent.jsx